import type { RouteLocationNormalized } from "vue-router";
/**
 * Ensures user is authenticated
 */
// eslint-disable-next-line no-restricted-exports
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const { slug } = storeToRefs(useSlugStore());

    if (!slug.value) {
        return showError({
            statusCode: 404,
        });
    }

    if (isGuestPage(to)) {
        return;
    }

    const { isLoggedIn } = storeToRefs(useTokenStore());

    if (to.name !== "slug-entrance" && !isLoggedIn.value) {
        return navigateTo({
            name: "slug-login",
            params: {
                slug: slug.value,
            },
            ...(!is404Page(to) && { query: { redirect: to.fullPath } }),
        });
    }
});
